import { useData } from '../context/DataContext';
import './Careers.css';

export default function Careers() {
  const { data, loading } = useData();
  if (loading || !data) return <div className="page">Loading...</div>;
  const { careers, company } = data;

  return (
    <main className="page careers-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">Join the Team</span>
          <h1 className="section-title__heading">Careers at IWX</h1>
          <p className="section-title__description">
            Help us build the future of interconnected digital services. We&apos;re looking for passionate innovators.
          </p>
        </div>

        <section className="careers-page__culture">
          <div className="careers-page__culture-grid">
            <div className="careers-page__perk">
              <h3>🌍 Remote-First</h3>
              <p>Work from anywhere in the world. We believe in flexibility and trust.</p>
            </div>
            <div className="careers-page__perk">
              <h3>🚀 Fast Growth</h3>
              <p>Join a rapidly scaling company building products across 10+ industries.</p>
            </div>
            <div className="careers-page__perk">
              <h3>🧠 Learning Culture</h3>
              <p>Continuous learning opportunities with access to courses, conferences, and mentorship.</p>
            </div>
            <div className="careers-page__perk">
              <h3>🎯 Impactful Work</h3>
              <p>Your code will power products used by millions across the globe.</p>
            </div>
          </div>
        </section>

        <section className="careers-page__openings">
          <h2 className="about-page__subtitle about-page__subtitle--center">Open Positions</h2>
          <div className="careers-page__list">
            {careers.map(job => (
              <div key={job.id} className="careers-page__job">
                <div className="careers-page__job-info">
                  <h3 className="careers-page__job-title">{job.title}</h3>
                  <p className="careers-page__job-desc">{job.description}</p>
                </div>
                <div className="careers-page__job-meta">
                  <span className="careers-page__job-tag">{job.department}</span>
                  <span className="careers-page__job-tag">{job.location}</span>
                  <span className="careers-page__job-tag">{job.type}</span>
                </div>
                <a href={`mailto:${company.email}?subject=Application: ${job.title}`} className="btn btn--outline btn--sm">
                  Apply Now
                </a>
              </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
